module.exports = __webpack_public_path__ + "img/1.2_Russian_road_sign.09ee1d66.svg";